import {
    generateBrandTreezRoute,
    generateOrganizationCatalogRoute,
    generatePriceTierManagementRoute,
    generateStoresPageRoute,
} from '../../../Routes';

export const useUIWrapperRoutes = (parentOrgId) => {
    const {pathname: brandTreezUrl} = generateBrandTreezRoute(parentOrgId);
    const {pathname: centralCatalogUrl} = generateOrganizationCatalogRoute(parentOrgId);
    const {pathname: storesUrl} = generateStoresPageRoute(parentOrgId);
    const {pathname: priceTiersUrl} = generatePriceTierManagementRoute(parentOrgId);

    return {brandTreezUrl, centralCatalogUrl, storesUrl, priceTiersUrl};
};
